/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Youtube_Export_Pick_FileInputs */

const cs_youtube_export_pick_file = /** @type {(inputs: Youtube_Export_Pick_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vybrat video`)
};

const en_youtube_export_pick_file = /** @type {(inputs: Youtube_Export_Pick_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose video file`)
};

/**
* | output |
* | --- |
* | "Choose video file" |
*
* @param {Youtube_Export_Pick_FileInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const youtube_export_pick_file = /** @type {((inputs?: Youtube_Export_Pick_FileInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Youtube_Export_Pick_FileInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_youtube_export_pick_file(inputs)
	return cs_youtube_export_pick_file(inputs)
});